module.exports = __webpack_public_path__ + "static/media/resturant-menu-theme-1.286a1a08.jpg";